import React, {Component} from 'react';
import {Select} from "antd";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {
	setSelectedRoomStayUUID,
	setSingleBooking,
} from '../store/actions/bookings';

class BookingSelector extends Component {

	selectBooking = (value) => {
		const uuid = this.props.availableBookings.filter(booking => (
			booking.roomStayUUID === value
		));
		if (uuid && uuid.length > 0) {
			//we found booking
			const current = this.props.location.pathname;
			this.props.dispatch(setSelectedRoomStayUUID(uuid[0].roomStayUUID));
			this.props.dispatch(setSingleBooking(uuid[0].uuid, this.props.history, current));
		}
	};

	massageDate = (date) => {
		return date.split("-").reverse().join("/");
	}

	render() {

		const { failed, selectedReference, availableBookings } = this.props;

		if(failed) {
			return null;
		}
		return <div className="ant-breadcrumb top-bar--wrapper p-t-21 p-b-21 p-r-10" style={{textAlign: "right"}}>

			<span className={"m-r-10 top-bar--booking-indicator-text"}>
				Your Bookings
			</span>

			{selectedReference ?
				<Select defaultValue={selectedReference}
				        style={{width: 400}}
				        onChange={this.selectBooking}>
					{availableBookings.map(booking => {
						return <Select.Option key={booking.roomStayId}
						                      value={booking.roomStayUUID}>{booking.buildingName} {this.massageDate(booking.startDate)} to {this.massageDate(booking.endDate)}</Select.Option>;
					})
					}
				</Select>
				:
				null
			}
		</div>
	}
}

const mapStateToProps = state => {
	const reference = state.bookings.availableBookings.filter(booking => (
		booking.roomStayUUID === state.bookings.selectedRoomStayId
	));

	return {
		availableBookings: state.bookings.availableBookings,
		loading: state.bookings.loading,
		selectedBookingId: state.bookings.selectedBookingId,
		failed: state.bookings.failed,
		selectedReference: reference && reference.length > 0 ? reference[0].roomStayUUID : false
	};
};

//export default connect(mapStateToProps)(BookingSelector);
export default withRouter(connect(mapStateToProps)(BookingSelector));
